// YERİ: src/app/core/tenant-host/tenant-host.guards.ts
//
// Kök rotanın host'a göre dallanması (bkz. app.routes.ts):
//   - kiracı host'u  → kiracı vitrini (domains/site/tenant-site.routes)
//   - platform host'u → melbarrel.com tanıtım sitesi (domains/website/routes)
// ve kiracı host'unda açılmaması gereken platform yollarının yönlendirmesi.

import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, UrlMatcher, UrlSegment } from '@angular/router';
import { TenantHostService } from './tenant-host.service';
import { isPlatformOnlyPath, platformAppUrl } from './tenant-host';

/** Yalnız kiracı host'unda eşleşir. */
export const tenantHostOnly: CanMatchFn = () => inject(TenantHostService).isTenantHost;

/**
 * Kiracı host'u ama kiracı ÇÖZÜLEMEDİ (bilinmeyen / doğrulanmamış alan adı).
 * Bekleyerek eşleşir: çözüm bitmeden hiçbir vitrin rotası seçilmez.
 */
export const tenantUnresolved: CanMatchFn = async () =>
  (await inject(TenantHostService).resolve()) === null;

/** Kiracı host'unda platform uygulamasına ait yollar ('/portal', '/admin', '/site/<id>'…). */
export const platformOnlyPathMatcher: UrlMatcher = (segments: UrlSegment[]) =>
  isPlatformOnlyPath('/' + segments.map(s => s.path).join('/')) ? { consumed: segments } : null;

/**
 * Aynı yolu app.melbarrel.com'da açar.
 *
 * Sunucuda buraya normalde hiç gelinmez: server.ts bu yolları kiracı host'unda
 * Angular'a sokmadan 302 ile gönderiyor (portal/admin zaten yalnız istemci
 * render'ı). Burası tarayıcı içi gezinmeyi (ör. 401 sonrası giriş ekranına
 * yönlendirme) yakalar. Dış adrese Router ile gidilemez — `location.href`.
 */
export const redirectToPlatformApp: CanActivateFn = (_route, state) => {
  if (isPlatformBrowser(inject(PLATFORM_ID))) {
    const loc = inject(DOCUMENT).location;
    if (loc) loc.href = platformAppUrl(state.url);
  }
  return false;
};
